/*Payment Detail*/
export const GET_PAYMENT_DETAIL = "GET_PAYMENT_DETAIL"
export const GET_PAYMENT_DETAIL_SUCCESS = "GET_PAYMENT_DETAIL_SUCCESS"
export const GET_PAYMENT_DETAIL_FAIL = "GET_PAYMENT_DETAIL_FAIL"